.group {
  display: inline-flex;
  flex: none;
  gap: 2px;
  padding: 2px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-control);
  background: var(--surface-sunken);
}

.segment {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  block-size: 26px;
  padding: 0 10px;
  border: 0;
  border-radius: var(--radius-small);
  background: transparent;
  color: var(--text-muted);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
  cursor: pointer;
}

.segment:hover {
  color: var(--text);
}

.segment:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.segment[aria-pressed="true"] {
  background: var(--surface-raised);
  color: var(--text);
  box-shadow: 0 0 0 1px var(--border);
}

.iconOnly .segment {
  inline-size: 28px;
  padding: 0;
  justify-content: center;
}
